<template>
  <div id="index" class="index">
    <div class="index-page">
      <img src="../img/index.jpg" @click="checkAuth" alt />
      <img class="index-btn" src="../img/index-btn.png" alt="" @click="checkAuth">
      <button class="rule-btn" type="button" name="button" @click="jumpRule">活动规则？</button>
    </div>
  </div>
</template>

<script>
import { checkAlipayAuth } from 'common/js/api'
import { isAlipay, isWechat } from 'common/js/util'
export default {
  name: 'index',
  data(){
    return{
    }
  },
  created(){
     
  },
  methods: {
    async checkAuth() {
      const url = `${this.$baseURL.cat}/dist/${this.$key}/jump.html${window.location.search}`
      const res = await checkAlipayAuth.call(this, url)
      // 统计信息
      let label
      if (isAlipay) {
        label = '支付宝'
      } else if (isWechat) {
        label = '微信'
      } else {
        label = '其他'
      }
      typeof _czc !== 'undefined' && _czc.push(['_trackEvent', `${this.$key}`, '跳转游戏页', label])
      if (res.code === 0) {
        window.location.href = url
      } else if (res.code === 5) {
        window.location.href = res.data.jump_url
      } else {
        this.$toast(res.msg)
      }
    },
    jumpRule() {
      if (isAlipay) {
        const url = `${this.$baseURL.cat}/dist/${this.$key}/rule.html`
        ap.pushWindow(url)
      } else {
        window.location.href = `${this.$baseURL.cat}/dist/${this.$key}/rule.html`
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background: #e76f61;
}
.index {
  display: flex;
  justify-content: center;
  align-items: top;
  height: 100vh;
  .index-page {
    position: relative;
    img {
      width: 750px;
    }
    .index-btn {
      position: absolute;
      top: 1035px;
      left: 127px;
      width:496px;
      height:112px;
      animation: btnScale 1.2s infinite ease-in;
    }
    .rule-btn {
      height: 40px;
      color: #fff;
      padding: 0 30px;
      font-size: 26px;
      display: flex;
      align-items: center;
      box-sizing: content-box;
      background: transparent;
      border: 0;
      position: absolute;
      top: 1150px;
      left: 295px;
      width: 160px;
    }
  }
}
</style>
